export var OptionsGroupItemType;
(function (OptionsGroupItemType) {
    OptionsGroupItemType["ACCESSORIES"] = "ACCESSORIES";
    OptionsGroupItemType["PROTECTION"] = "PROTECTION";
    OptionsGroupItemType["WARRANTY"] = "WARRANTY";
})(OptionsGroupItemType || (OptionsGroupItemType = {}));
export const optionsGroupItemKeys = {
    LeaseAccessories: OptionsGroupItemType.ACCESSORIES,
    FinanceAccessories: OptionsGroupItemType.ACCESSORIES,
    CashAccessories: OptionsGroupItemType.ACCESSORIES,
    LeaseOwnerProgram: OptionsGroupItemType.PROTECTION,
    FinanceOwnerProgram: OptionsGroupItemType.PROTECTION,
    CashOwnerProgram: OptionsGroupItemType.PROTECTION,
    LeaseWarranty: OptionsGroupItemType.WARRANTY,
    FinanceWarranty: OptionsGroupItemType.WARRANTY,
    CashWarranty: OptionsGroupItemType.WARRANTY,
};
export var OptionsLabel;
(function (OptionsLabel) {
    OptionsLabel["title"] = "Options";
    OptionsLabel["key"] = "OptionsGroup";
})(OptionsLabel || (OptionsLabel = {}));
